export const FlagPL = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" style={{ borderRadius: '50%', border: '1px solid #cbd5e1', display: 'block' }}>
    <rect width="20" height="10" fill="#ffffff" />
    <rect y="10" width="20" height="10" fill="#dc143c" />
  </svg>
)

export const FlagES = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" style={{ borderRadius: '50%', border: '1px solid #cbd5e1', display: 'block' }}>
    <rect width="20" height="5" fill="#c60b1e" />
    <rect y="5" width="20" height="10" fill="#fecb00" />
    <rect y="15" width="20" height="5" fill="#c60b1e" />
  </svg>
)

export const FlagUS = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" style={{ borderRadius: '50%', border: '1px solid #cbd5e1', display: 'block' }}>
    <rect width="20" height="20" fill="#ffffff" />
    <rect y="0" width="20" height="1.54" fill="#b22234" />
    <rect y="3.08" width="20" height="1.54" fill="#b22234" />
    <rect y="6.15" width="20" height="1.54" fill="#b22234" />
    <rect y="9.23" width="20" height="1.54" fill="#b22234" />
    <rect y="12.31" width="20" height="1.54" fill="#b22234" />
    <rect y="15.38" width="20" height="1.54" fill="#b22234" />
    <rect y="18.46" width="20" height="1.54" fill="#b22234" />
    <rect width="10.8" height="10.8" fill="#3c3b6e" />
    <circle cx="2.7" cy="2.7" r="0.6" fill="#ffffff" />
    <circle cx="5.4" cy="2.7" r="0.6" fill="#ffffff" />
    <circle cx="8.1" cy="2.7" r="0.6" fill="#ffffff" />
    <circle cx="2.7" cy="5.4" r="0.6" fill="#ffffff" />
    <circle cx="5.4" cy="5.4" r="0.6" fill="#ffffff" />
    <circle cx="8.1" cy="5.4" r="0.6" fill="#ffffff" />
    <circle cx="2.7" cy="8.1" r="0.6" fill="#ffffff" />
    <circle cx="5.4" cy="8.1" r="0.6" fill="#ffffff" />
    <circle cx="8.1" cy="8.1" r="0.6" fill="#ffffff" />
  </svg>
)
